/* eslint-disable camelcase */
import React, { forwardRef, useEffect, useState } from "react"
import { useSelector } from "react-redux"
import dynamic from "next/dynamic"
import _isEqual from "lodash/isEqual"
import _isEmpty from "lodash/isEmpty"
import { NumericFormat } from "react-number-format"
import cx from "classnames"
import useWindowResize from "@/hooks/useWindowResize"
import {
  isCanadaSite,
  sanitizeAndDecodeHtml,
  sanitizeInnerHtml,
} from "@/utils/helper"
import { getBundleIncludedItems } from "@/components/ProductDetail/v3/ProductDetailView/ProductDescription/utils"

import { selectPdpState } from "@/store/features/pdpSlice"

import {
  initPriceSpider,
  getDataSheetUrl,
} from "@/components/ProductDetail/v3/productDetailsHelper"
import { compareState } from "@/store/features/compareSlice"

import {
  addDataLayerSuperSkuOptionSelected,
  getEventInfo,
} from "@/components/ProductDetail/v3/analytics"
import {
  addAnalyticsPdpAffirmText,
  addAnalyticsForRightToKnowInfoButtonClick,
  addAnalyticsForConfiguratorButtonClick,
  addAnalyticsForConfiguratorModal,
  addAnalyticsForConfiguratorError,
} from "@/components/ProductDetail/v3/ProductDetailView/analytics/analytics"

import Accordion from "@/components/core/Accordion/Accordion"
import ListPrice from "@/components/ProductDetail/v3/ProductDetailView/ListPrice"
import SwatchList from "@/components/ProductDetail/v3/ProductDetailView/SwatchList"
import SuperSkuOption from "@/components/ProductDetail/v3/SuperSkuOption"
import InstallReqItems from "@/components/ProductDetail/v3/ProductDetailView/InstallReqItems"
import AddToCart from "@/components/ProductDetail/v3/AddToCart"
import MoreFromCollection from "@/components/ProductDetail/v3/MoreFromCollection"
import ProductAccordionList from "@/components/ProductDetail/v3/ProductAccordionList"
import Feedback from "@/components/ProductDetail/v3/ProductDetailView/ProductDescription/Feedback"

import Product3Dmodel from "@/components/ProductDetail/v3/ProductDetailView/Product3Dmodel"
import ProductOnDisplay from "@/components/ProductDetail/v3/ProductDetailView//ProductOnDisplay"
import StaticBundle from "@/components/Bundles/StaticBundle"
import BundlesAccordian from "@/components/Bundles/StaticBundle/BundlesAccordian"
import BundleHighlights from "@/components/Bundles/StaticBundle/BundlesHighlights"
const Threekit = dynamic(() => import("@/components/Threekit/"))
import Configurator from "@/components/ProductDetail/v3/Configurator"
import AlbyQA from "@/components/AlbyQA"

import toolTipInfoIcon from "@/public/icons/tooltip-info.svg"
import Modal from "@/components/core/Modal/Modal"
import Button from "@/components/core/Button/Button"
import { selectGenericState } from "@/store/features/genericSlice"
import Script from "next/script"

const ProductDescription = forwardRef((props, ref) => {
  const { rightSectionRef, addCartContainer } = ref
  const {
    badgeTxt = "",
    isDiscontinued = false,
    discontinuedProduct = false,
    staticTexts = {},
    name = "",
    desc = "",
    customerFacingSKU = "",
    sku = "",
    price = 0,
    isPersonaANY = false,
    ProductPriceSpiderIncluded_s: isPriceSpider = false,
    discountPercent = 0,
    discountedPrice = 0,
    isType = "",
    persona = "",
    productInfo,
    handleSetPriceTooltip = () => {},
    options = [],
    curroptions = [],
    facetLabels = [],
    variantOptions = [],
    selectMoreTooltipData = "",
    selectoption = () => {},
    isRegionSoldOnline = true,
    addToCartProps = {},
    addToCartProps: { specialOrder = "", backOrder = "" } = {},
    productOnStock = 0,
    promoTitle = "",
    isProjectPack = "",
    disableEcommerce = false,
    freightPolicyType = "",
    excludedState = "",
    productAnalyticsData = {},
    onQtyChange = () => {},
    comparedProductsCount = 0,
    isColorDiscontinued = false,
    handleNavChange = () => {},
    onAddToCompare = () => {},
    onRemoveFromCompare = () => {},
    checkProductCategory = () => {},
    isComboSku = false,
    productCategory = "",
    isParts = false,
    showToaster = () => {},
    onAvailableColor = () => {},
    findStoreUrl = "",
    isFavorite = false,
    favItem = [],
    ctData = {},
    ctProductId = "",
    customerBrandName = "",
    replaceAddToCart = false,
    disableRatings = false,
    replaceAddToCartCtaLink = "",
    replaceAddToCartCtaLabel = "",
    linkNewTab = false,
    fusionQueryId = "",
    docId = "",
    narrativeDescription = "",
    partReplacementSuggestions = "",
    pdpJson = {},
    promoDescription = "",
    onAddToCart = () => {},
    mboxes = [],
    presetConfigObject = {},
    productType = "",
    installationDataFromProp = [],
    designServiceDataFromProp = [],
    installationData = [],
    productData = {},
    businessUnitName = "",
    discontinuedProductb = "",
    ProductRequiredAccessoriesGroupsList = [],
    superSku = "",
    designServiceData = [],
    productServices = [],
    getZipCode = () => {},
    brandName = "",
    config = {},
    colorsData = {},
    zipCodeData = [],
    isPdpPropsLoaded = false,
    isPriceChecked = false,
    listPrice = 0,
    features = "",
    imagesData = [],
    dimensionData = {},
    specificationData = {},
    savedListLineItems = {},
    isSkuOptionClicked = false,
    setIsSkuOptionClicked = () => {},
    widgetId = "",
    masterVariantProductNo = "",
    albyThreadId = "",
    showAlby = false,
  } = props || {}

  const {
    pdp: {
      data: { primaryBundleSKU_s: primaryBundleSKUs = "" } = {},
      sku: currentSku = "",
      bundleIncludedItems = [],
      configuratorEnabled = false,
    } = {},
    productServices: currentProductServices = [],
  } = useSelector(selectPdpState) || {}

  const { feedbackFormID = "", priceSpiderScript = "" } = pdpJson

  const dataSheetUrl = getDataSheetUrl(currentProductServices, currentSku)

  const isBundleProduct = Boolean(primaryBundleSKUs)

  const {
    apiEndpoints: { productsOnDisplayEndpoint = "" } = {},
    general: {
      shortendPagePath = "",
      storeDetailsServletPath = "",
      disableCommerce = false,
      siteName = "",
    } = {},
    internationalization: {
      locale = "",
      currencySign = "",
      currencyCode = "",
    } = {},
  } = config

  const { ingredientsLabel = "" } = staticTexts

  const isKohler = siteName === "Kohler"

  const {
    ResourceNvznIdList_ss: nvznList = [],
    ResourceVntanaProductIdList_ss: vntanaList = [],
  } = productData

  const overSizedType = "4"
  const compare = useSelector(compareState)
  const { featureFlags } = useSelector(selectGenericState)
  const {
    MYSQLCONNSTR_ENABLE_CONFIGURATOR: isConfiguratorEnabled = false,
    MYSQLCONNSTR_ENABLE_PDP_AFFIRM: isPdpAffirmEnabled = true,
  } = featureFlags

  const [width, height] = useWindowResize()
  const [showPromo, setShowPromo] = useState(false)
  const [descShowMore, setDescShowMore] = useState(false)
  const [allowedDescCount, setAllowedDescCount] = useState(0)
  const [selectedSkuIsFav, setSelectedSkuIsFav] = useState(false)
  const [optionValue, setOptionValue] = useState("")
  const [optionDropdownName, setOptionDropdownName] = useState("")
  const [showEdit, setShowEdit] = useState(false)
  const [configuratorError, setConfiguratorError] = useState(false)

  useEffect(() => {
    if (narrativeDescription) {
      const descCount = narrativeDescription?.length ?? 0
      const allowedCount = width > 1023 && width < 1280 ? 230 : 300
      setAllowedDescCount(allowedCount)
      setDescShowMore(descCount > allowedCount)
    }
  }, [narrativeDescription, width])

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.addEventListener("scroll", handleScrollRight)
      return () => {
        window.removeEventListener("scroll", handleScrollRight)
      }
    }
  }, [])

  useEffect(() => {
    if (optionValue && optionDropdownName) {
      addDataLayerSuperSkuOptionSelected(
        optionValue?.optionLabel,
        optionDropdownName,
        productInfo
      )
      setOptionValue("")
      setOptionDropdownName("")
      setIsSkuOptionClicked(false)
    }
  }, [isSkuOptionClicked])

  const handleSelectoption = (data, facetValues) => {
    const { facet } = data
    const dropdownName = facetValues[facet]
    setOptionValue(data)
    setOptionDropdownName(dropdownName)
    selectoption && selectoption(data, facet)
  }

  const handleButtonClick = () => {
    setShowEdit(true)
    addAnalyticsForConfiguratorButtonClick(
      productInfo,
      staticTexts?.configuratorButtonLabel?.toLowerCase()
    )
  }

  const closeForm = () => {
    setShowEdit(false)
    addAnalyticsForConfiguratorModal(
      productInfo,
      staticTexts?.configuratorButtonLabel?.toLowerCase(),
      "close"
    )
  }

  const configuratorModalOpenSuccessCallback = () => {
    addAnalyticsForConfiguratorModal(
      productInfo,
      staticTexts?.configuratorButtonLabel?.toLowerCase(),
      "open"
    )
  }

  useEffect(() => {
    if (configuratorError === true) {
      addAnalyticsForConfiguratorError(
        productInfo,
        staticTexts?.configuratorButtonLabel?.toLowerCase()
      )
    }
  }, [configuratorError])

  const handleScrollRight = () => {
    const rightSecHeight = rightSectionRef.current?.clientHeight
    if (rightSectionRef.current && width >= 1024) {
      rightSectionRef.current.style.top = `-${rightSecHeight - height}px`
    }
  }

  useEffect(() => {
    if (isPriceSpider) {
      initPriceSpider(productInfo)
    }
  }, [isPriceSpider])

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.PriceSpider?.rebind()
      getSelectedSkuIsFavValue(favItem, sku)
    }
  }, [sku, ctData?.id])

  const getSelectedSkuIsFavValue = (favList, skuId) => {
    const isItem =
      Array.isArray(favList) &&
      favList.some(fav => {
        return fav?.variant?.sku === skuId
      })
    setSelectedSkuIsFav(isItem)
  }

  const productPrice =
    !isBundleProduct && discountedPrice > 0 ? discountedPrice : price

  const dataAmountAffirm = productPrice * 100

  const isAffirmLite = isPdpAffirmEnabled && productPrice > 150

  useEffect(() => {
    if (isAffirmLite && dataAmountAffirm && window?.affirm?.ui?.refresh) {
      window.affirm?.ui?.refresh()
    }
  }, [dataAmountAffirm, isAffirmLite])

  const affirmDetailsClick = () => {
    const affirmClickText =
      document
        ?.querySelector(".affirm-modal-trigger")
        ?.innerText?.toLowerCase() || ""
    const affirmTitle =
      document?.querySelector(".affirm-as-low-as")?.innerText?.toLowerCase() ||
      ""
    const pdpAffirmLetter = affirmTitle?.split(". ")
    addAnalyticsPdpAffirmText(
      pdpAffirmLetter[0],
      affirmClickText,
      productInfo,
      isBundleProduct
    )
  }

  const includedItems = getBundleIncludedItems({
    items: bundleIncludedItems,
    ctData,
    projectionData: currentProductServices,
    currencyCode,
    persona,
  })

  const staticBundleData = {
    productPrice,
    currencySign,
    listPrice,
    lineItem: includedItems,
  }

  const productOnDisplayData = { name, desc, imagesData }
  const isProductDiscontinued = isDiscontinued || isColorDiscontinued

  const getSelectedSkuIsFavValueAddAndRemove = (favItems, variantSkuId) => {
    const totalVarians = []
    ctData?.variants?.forEach(variant => {
      totalVarians.push(variant)
    })
    totalVarians.push(ctData?.masterVariant)
    const item = favItems.find(
      vl =>
        vl.productId === ctData?.id &&
        totalVarians?.find(
          vt => vt.sku === variantSkuId && vt?.id === vl?.variantId
        )
    )
    if (item) {
      setSelectedSkuIsFav(true)
    } else {
      setSelectedSkuIsFav(false)
    }
  }

  const handleClick = () => {
    addAnalyticsForRightToKnowInfoButtonClick(productInfo)
    window.open(dataSheetUrl)
  }

  const handleReadMoreClick = () => {
    setDescShowMore(false)
  }

  return (
    <div ref={rightSectionRef} className="product-detail-page__right-sticky">
      <div className="row product-detail-page__main">
        <div className="col-12">
          {((badgeTxt && !isDiscontinued) || discontinuedProduct) && (
            <div className="product-detail-page__badge">
              {!isDiscontinued && badgeTxt !== "" && (
                <label className="product-detail-page__badge-new">
                  {badgeTxt}
                </label>
              )}
              {discontinuedProduct && (
                <p className="product-detail-page__badge-discontinued">
                  {staticTexts?.discontinued}
                </p>
              )}
            </div>
          )}
          {name || desc ? (
            <h1 className="product-detail-page__title-desc">
              <span className="product-detail-page__title">
                {name ? name : desc}
              </span>
              {name && desc && name.toLowerCase() !== desc.toLowerCase() && (
                <p className="product-detail-page__description"> {desc}</p>
              )}
            </h1>
          ) : (
            <h1 className="product-detail-page__title-desc">
              <span className="product-detail-page__title">
                <p className="shimmer-loading__para shimmer width-170"></p>
              </span>
              <p className="shimmer-loading__para shimmer width-170 product-detail-page__description"></p>
            </h1>
          )}
          {customerFacingSKU || sku ? (
            <span className="product-detail-page__sku-id">
              {customerFacingSKU || sku}
            </span>
          ) : (
            <span className="product-detail-page__sku-id">
              <p className="shimmer-loading__para shimmer width-170"></p>
            </span>
          )}
        </div>
      </div>
      {!isDiscontinued ? (
        <div
          className={cx({
            "row no-gutters product-detail-page__price-main": true,
            "price-retail-exclusive": isPriceSpider,
          })}
        >
          {!isPriceChecked ? (
            <div className="col-12 product-detail-page__price">
              <div className="product-detail-page__price-value">
                <p className="shimmer-loading__para shimmer width-170"></p>
              </div>
            </div>
          ) : productPrice > 0 ? (
            <>
              <div className="col-12 product-detail-page__price">
                {!isCanadaSite(brandName) && !isPersonaANY && (
                  <div className="product-detail-page__price-value">
                    <label
                      htmlFor="product-detail-page__current-price-value"
                      className="product-detail-page__sr-price-label screen-reader-hidden-label"
                    >
                      {`${staticTexts.currentPriceAriaLabel} ${currencySign}${productPrice}`}
                    </label>
                    <NumericFormat
                      value={productPrice}
                      displayType={"text"}
                      thousandSeparator={true}
                      prefix={currencySign}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      id="product-detail-page__current-price-value"
                      aria-hidden
                    />
                  </div>
                )}
                {price && (persona === "FF" || persona === "KEMP") && (
                  <div className="product-detail-page__customer-group">
                    {persona === "FF" && (
                      <span>{staticTexts?.friendsFamilyPrice}</span>
                    )}
                    {persona === "KEMP" && (
                      <span>{staticTexts?.associatePrice}</span>
                    )}
                  </div>
                )}
              </div>
              {!disableCommerce && discountedPrice > 0 && !isBundleProduct ? (
                <div className="col-12 product-detail-page__discount">
                  <span className="product-detail-page__discount-price">
                    <NumericFormat
                      value={price}
                      displayType="text"
                      thousandSeparator={true}
                      prefix={currencySign}
                      decimalScale={2}
                      fixedDecimalScale={true}
                    />
                  </span>
                  {discountPercent > 0 && (
                    <span className="product-detail-page__percent-off">
                      {isType === "absolute"
                        ? currencySign + discountPercent
                        : discountPercent + "%"}{" "}
                      {staticTexts?.percentOff}
                    </span>
                  )}
                </div>
              ) : null}

              {price && !isPriceSpider && !isDiscontinued && (
                <div className="product-detail-page__list-price--associate">
                  <ListPrice
                    {...props}
                    handleSetPriceTooltip={handleSetPriceTooltip}
                  />
                </div>
              )}
              {isAffirmLite ? (
                <div className="product-detail-page__affirm-messaging">
                  <p
                    className="affirm-as-low-as"
                    data-page-type="product"
                    data-amount={dataAmountAffirm}
                    onClick={affirmDetailsClick}
                  />
                </div>
              ) : null}
            </>
          ) : null}
        </div>
      ) : null}
      {showEdit ? (
        <Threekit
          showEdit={showEdit}
          closeForm={closeForm}
          persona={persona}
          currency={currencySign}
          currencyCode={currencyCode}
          onAddToCart={onAddToCart}
          brandName={brandName}
          customerBrandName={customerBrandName}
          setConfiguratorError={setConfiguratorError}
          configuratorModalOpenSuccessCallback={
            configuratorModalOpenSuccessCallback
          }
        />
      ) : null}
      {isBundleProduct ? <BundleHighlights features={features} /> : null}
      <SwatchList {...props} />
      {isBundleProduct ? (
        <StaticBundle pdpView data={staticBundleData} page="pdp" />
      ) : null}

      {!isDiscontinued && Object.keys(options).length > 0 ? (
        <div className="row no-gutters">
          <SuperSkuOption
            i18n={staticTexts}
            options={options}
            curroptions={curroptions}
            selectoption={handleSelectoption}
            facetLabels={facetLabels}
            tooltipdata={selectMoreTooltipData}
            selectMoreTooltipHandler={handleSetPriceTooltip}
            variantOptions={variantOptions}
          />
        </div>
      ) : null}
      <InstallReqItems currencyCode={currencyCode} {...props} />
      {isRegionSoldOnline && specialOrder === "Yes" && (
        <div className="product-detail-page__discontinued-txt product-detail-page__order-messaging">
          {staticTexts?.specialOrder}
        </div>
      )}

      {isPriceSpider && (
        <div className="product-detail-page__price-spider-section">
          <p className="product-detail-page__price_spider_title">
            {staticTexts?.priceSpiderTitle}
          </p>
          <div className="ps-widget" ps-sku={sku} />
        </div>
      )}

      {promoTitle &&
        !isPriceSpider &&
        isRegionSoldOnline &&
        !isDiscontinued &&
        !isProjectPack &&
        (backOrder === "Yes" || productOnStock > 0) && (
          <div className="product-detail-page__promo-section">
            <Accordion
              isOpen={false}
              title={promoTitle}
              handleOpen={() => setShowPromo(true)}
              handleClose={() => setShowPromo(false)}
              isArrow={true}
            >
              {showPromo && promoDescription && (
                <p className="product-detail-page__promo-desc">
                  {sanitizeInnerHtml(promoDescription)}
                </p>
              )}
            </Accordion>
          </div>
        )}

      {!disableEcommerce &&
        !isPriceSpider &&
        isRegionSoldOnline &&
        !isDiscontinued &&
        !isProjectPack &&
        productOnStock > 0 &&
        (_isEqual(freightPolicyType, overSizedType) ||
          !_isEmpty(excludedState)) && (
          <div className="row no-gutters product-detail-page__oversized-msg-section">
            <div className="col-12 oversized-msg-tooltip">
              {_isEqual(freightPolicyType, overSizedType) && (
                <span className="oversized-msg-primary-txt">
                  <img
                    className="oversized-msg-info-icon"
                    src={toolTipInfoIcon.src}
                    alt={staticTexts?.toolTip}
                  />
                  <span>
                    {sanitizeInnerHtml(staticTexts?.primaryTxt)}{" "}
                    {sanitizeInnerHtml(staticTexts?.secondaryTxt)}
                  </span>
                </span>
              )}

              {!_isEmpty(excludedState) && (
                <span className="oversized-msg-primary-txt">
                  <img
                    className="oversized-msg-info-icon"
                    src={toolTipInfoIcon.src}
                    alt={staticTexts?.toolTip}
                  />
                  <span>
                    {sanitizeInnerHtml(
                      `${staticTexts?.shippingTitle} ${staticTexts?.shippingDescription} ${excludedState}.`
                    )}
                  </span>
                </span>
              )}
            </div>
          </div>
        )}
      {!isPriceSpider &&
        !isDiscontinued &&
        productPrice <= 0 &&
        isPriceChecked && (
          <div className="row no-gutters">
            <div className="col-12 product-detail-page__info-mssg">
              <p>{sanitizeAndDecodeHtml(staticTexts?.withoutPriceTxt)}</p>
            </div>
          </div>
        )}

      {isProjectPack && (
        <div className="row no-gutters">
          <div className="col-12 product-detail-page__info-mssg">
            <p>{sanitizeAndDecodeHtml(staticTexts?.projectPackMssg)}</p>
          </div>
        </div>
      )}
      <AddToCart
        ref={addCartContainer}
        {...addToCartProps}
        staticTexts={staticTexts}
        onQtyChange={qty => onQtyChange(qty)}
        onAddToCart={onAddToCart}
        onAdd={onAddToCompare}
        onRemove={onRemoveFromCompare}
        onAvailableColor={onAvailableColor}
        checkCategory={checkProductCategory}
        comparedProductsCount={comparedProductsCount}
        compareData={compare}
        sku={sku}
        masterSku={productData?.masterSKU_s}
        isComboSku={isComboSku}
        productCategory={productCategory}
        isParts={isParts}
        productOnStock={productOnStock}
        isColorDiscontinued={isColorDiscontinued}
        isDiscontinued={isDiscontinued}
        specialOrder={specialOrder}
        backOrder={backOrder}
        ProductPriceSpiderIncluded_s={isPriceSpider}
        showToaster={showToaster}
        productData={productAnalyticsData}
        findStoreUrl={findStoreUrl}
        isFavorite={isFavorite}
        favItem={favItem}
        price={price}
        ctData={ctData}
        isRegionSoldOnline={isRegionSoldOnline}
        customerBrandName={customerBrandName}
        handleNavChange={handleNavChange}
        replaceAddToCart={replaceAddToCart}
        disableRatings={disableRatings}
        replaceAddToCartCtaLink={replaceAddToCartCtaLink}
        replaceAddToCartCtaLabel={replaceAddToCartCtaLabel}
        linkNewTab={linkNewTab}
        disableEcommerce={disableEcommerce}
        fusionQueryId={fusionQueryId}
        docId={docId}
        analyticData={productAnalyticsData?.stringProductInfo}
        isPdpPropsLoaded={isPdpPropsLoaded}
        isBundleProduct={isBundleProduct}
        ctProductId={ctProductId}
        showFavirote={selectedSkuIsFav}
        resetSelectedFav={getSelectedSkuIsFavValueAddAndRemove}
        savedListLineItems={savedListLineItems}
        productInfo={productInfo}
      />
      {isConfiguratorEnabled && configuratorEnabled ? (
        <Configurator
          title={staticTexts.configuratorTitle}
          description={staticTexts.configuratorDesc}
          buttonLabel={staticTexts.configuratorButtonLabel}
          setError={setConfiguratorError}
          handleButtonClick={handleButtonClick}
        />
      ) : null}

      {configuratorEnabled && configuratorError ? (
        <div className="configurator-error-modal">
          <Modal
            showModal={configuratorError}
            onModalClose={() => {
              setConfiguratorError(false)
              closeForm()
            }}
          >
            <p className="error-title">{staticTexts.configuratorErrorTitle}</p>
            <p className="error-message">{staticTexts.configuratorErrorDesc}</p>
            <Button
              role="button"
              type="black"
              label={staticTexts.configuratorErrorButtonLabel}
              onClick={() => {
                setConfiguratorError(false)
                closeForm()
              }}
              flexible
            />
          </Modal>
        </div>
      ) : null}
      {nvznList.length || vntanaList.length ? (
        <Product3Dmodel
          pdpJson={pdpJson}
          nvznList={nvznList}
          vntanaList={vntanaList}
          sku={sku}
          productInfo={productInfo}
        />
      ) : null}
      {narrativeDescription && (
        <div className="product-detail-page__narrative-description">
          <p
            className={`product-detail-page__narrative-description${
              descShowMore ? "--show-more" : "--none"
            }`}
          >
            {descShowMore
              ? narrativeDescription.slice(0, allowedDescCount)
              : narrativeDescription}
            {descShowMore && (
              <span>
                ...
                <a
                  className="product-detail-page__narrative-description--show-more-button gbh-data-layer"
                  tabIndex={0}
                  onClick={handleReadMoreClick}
                  aria-label={`${staticTexts?.descReadMore} about ${
                    name || desc
                  }`}
                  data-gbh-data-layer={getEventInfo(
                    staticTexts.descReadMore.toLowerCase()
                  )}
                  data-gbh-data-layer-custom={
                    productAnalyticsData?.stringProductInfo
                  }
                >
                  {staticTexts?.descReadMore}
                </a>
              </span>
            )}
          </p>
        </div>
      )}
      {isKohler && dataSheetUrl && ingredientsLabel ? (
        <span className="ingredients-link" onClick={handleClick}>
          {ingredientsLabel}
        </span>
      ) : null}

      {discontinuedProduct && isParts && partReplacementSuggestions && (
        <MoreFromCollection
          pdpJson={pdpJson}
          sku={sku}
          i18n={{
            title: staticTexts?.moreCollection,
            discontinuedTitle: staticTexts?.moreCollectionDiscontinued,
            partNumber: staticTexts?.partNumber,
            partName: staticTexts?.partName,
          }}
          isColorDiscontinued={isColorDiscontinued}
          mboxes={mboxes}
          presetConfigObject={presetConfigObject}
          productType={productType}
          partReplacementSuggestions={partReplacementSuggestions}
        />
      )}
      {isBundleProduct ? (
        <BundlesAccordian items={includedItems} parentSku={currentSku} />
      ) : (
        <ProductAccordionList
          productData={productData}
          productInfo={productAnalyticsData.stringProductInfo}
          productSku={sku}
          isDiscontinued={isDiscontinued}
          staticTexts={staticTexts}
          accordionList={pdpJson?.accordianLabels || []}
          installationSupportLinks={pdpJson?.installationSupportLinks}
          installationDataFromProp={installationDataFromProp}
          designServiceDataFromProp={designServiceDataFromProp}
          businessUnitName={businessUnitName}
          ProductPriceSpiderIncluded_s={isPriceSpider}
          discontinuedProductb={discontinuedProductb}
          ProductRequiredAccessoriesGroupsList={
            ProductRequiredAccessoriesGroupsList
          }
          superSku={superSku}
          currencySign={currencySign}
          productCategory={productCategory}
          designServiceData={designServiceData}
          productServices={productServices}
          productType={productType}
          getZipCode={getZipCode}
          installationData={installationData}
          persona={persona}
          currencyCode={currencyCode}
          locale={locale}
          width={width}
          replaceAddToCart={replaceAddToCart}
          disableRatings={disableRatings}
          replaceAddToCartCtaLink={replaceAddToCartCtaLink}
          replaceAddToCartCtaLabel={replaceAddToCartCtaLabel}
          linkNewTab={linkNewTab}
          disableEcommerce={disableEcommerce}
          isProjectPack={isProjectPack}
          dimensionData={dimensionData}
          specificationData={specificationData}
          config={config}
        />
      )}
      {showAlby && width < 1024 ? (
        <AlbyQA
          widgetId={widgetId}
          skuId={masterVariantProductNo}
          threadId={albyThreadId}
        />
      ) : null}
      {zipCodeData.length && !isBundleProduct ? (
        <ProductOnDisplay
          pdpJson={pdpJson}
          productServices={productServices}
          installationData={installationData}
          staticTexts={staticTexts}
          currencyCode={currencyCode}
          currencySign={currencySign}
          brandName={brandName}
          getZipCode={getZipCode}
          findStores={productsOnDisplayEndpoint}
          colorsData={colorsData}
          shortendPagePath={shortendPagePath}
          findStoreDetailsUrl={storeDetailsServletPath}
          productType={productType}
          productInfo={productInfo}
          productOnDisplayData={productOnDisplayData}
          isRetailProduct={isPriceSpider}
          isParts={isParts}
          isProductDiscontinued={isProductDiscontinued}
          zipCodeData={zipCodeData}
        />
      ) : null}
      {feedbackFormID ? <Feedback pdpJson={pdpJson} /> : null}
      {isPriceSpider && priceSpiderScript ? (
        <Script src={priceSpiderScript} />
      ) : null}
    </div>
  )
})

ProductDescription.displayName = "ProductDescription"

export default ProductDescription
